import React from 'react';
import covenLogo from 'assets/viasForm/covenlabsFullLogo.svg';
import AsraLogo from 'assets/viasForm/asraFullLogo.png';
import { FaArrowRight } from 'react-icons/fa';

const data = [
  {
    logo: covenLogo,
    companyName: 'Coven Work',
    text:
      'Coven works is a leading data science and AI company dedicated to helping organizations recruit and build their staff with cutting-edge technology and expertise.',
    link: 'https://linktr.ee/covenworks',
    id: '1',
  },
  {
    logo: AsraLogo,
    companyName: 'Asra Nest LLC',
    text:
      'Asra Nest LLC redefines success by offering comprehensive consulting, hiring training, and talent acquisition and outsourcing solutions tailored to elevate businesses to new heights.',
    link: 'https://asranest.com/',
    id: '2',
  },
];

export const FillingCompanies = () => {
  return (
    <div style={{}}>
      <p style={{ color: '#62943B', fontWeight: '600', fontSize: '18px' }}>
        About our Filing Companies
      </p>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: '10px',
          gap: '20px',
        }}
      >
        {data.map(({ logo, id, text, companyName, link }) => {
          return (
            <div
              style={{
                background: `${
                  companyName === 'Coven Work' ? '#ECF8FF' : '#FFFCF5'
                }`,
                color: `${
                  companyName === 'Coven Work' ? ' #1481BA' : '#B54708'
                }`,
                padding: '10px',
              }}
            >
              <img src={logo} alt="Coven Works" />
              <p
                style={{
                  color: `${
                    companyName === 'Coven Work' ? ' #1481BA' : '#B54708'
                  }`,
                  fontWeight: '300',
                  padding: '10px 0px',
                }}
              >
                {text}
              </p>

              <p
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  color: `${
                    companyName === 'Coven Work' ? ' #1481BA' : '#B54708'
                  }`,
                  fontWeight: '600',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  window.open(link, '_blank');
                }}
              >
                Learn more <FaArrowRight />
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
